<template>
    <v-sheet  v-for="(item, i) in countEquipStatus" :key="i" class="defaultCard" color="bgtopology">
        <p :id="item.title"  class=" headTopo mb-3 pt-4 ml-4">
            <span class="titleDashboard"> {{ t(`labels.${item.title}`) }}</span>
        </p>

        <v-row class="ma-0" justify="center">
            <v-sheet v-if="smAndDown" color="transparent" width='420' style="align-content: start">
                <GaugeComponent
                :recharge="false"
                :array-items="item.totalGaug"
                />
            </v-sheet>
            <v-sheet color="transparent" :style="smAndDown ? 'width: 100%' : 'width: calc(100% - 420px)'">
                <v-sheet color="transparent" class="cardTopologys">  
                    <v-row class="ma-0" justify="center">
                        <v-col :class="smAndDown ? 'pb-4 mb-4' : 'pa-0 px-4'" cols="12" sm="8" md="4" lg="4" xl="3"  >
                            <SingleCard :bottomText="t('labels.alert_pl')" :icon="'mdi-exclamation-thick'" :color-icon="COLOR.red" :middleText="item.alert.cant.toString()"/>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" sm="12" md="8" lg="8" xl="9" >
                            <v-text-field
                            v-if="item.alert.table.length > 0"
                            :style="'max-width: 400px !important;'"
                            class="mb-5" 
                            v-model="item.salert"
                            :label="t('search')"
                            variant="outlined"
                            density="compact"                      
                            hide-details                     
                            ></v-text-field>
                            <EasyDataTable
                            v-if="item.alert.table.length > 0"
                            table-class-name="customize-table"
                            show-index
                            :headers="headersALEALA"
                            :items="item.alert.table"
                            :rows-per-page="rows"
                            :search-value="item.salert"
                            @click-row="showDialog"
                            >
                                <template #item-icon="item">
                                    <svg class="iconStatus" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="25px" viewBox="0 0 300.000000 300.000000" >
                                    <g v-html="getIMGsvg(item.tipo)"/>
                                    </svg>
                                </template>  
                                <template #item-ieo="item">
                                    <span>{{ getStatusIEO(item.host) }}</span>
                                </template>  
                            </EasyDataTable>
                            <p v-else>
                                <span>{{t('labels.noalerts')}} </span>
                            </p>
                        </v-col>
                    </v-row>
                </v-sheet>

                <v-sheet color="transparent" class="cardTopologys">
                    <v-row class="ma-0" justify="center">
                        <v-col :class="smAndDown ? 'pb-4 mb-4' : 'pa-0 px-4'" cols="12" sm="8" md="4" lg="4" xl="3">
                            <SingleCard  :bottomText="t('labels.alarm_pl')" :icon="'mdi-lightbulb-on-outline'" :color-icon="COLOR.yellow" :middleText="item.alarm.cant.toString()"/>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" sm="12" md="8" lg="8" xl="9" >
                            <v-text-field
                            v-if="item.alarm.table.length > 0"
                            :style="'max-width: 400px !important;'"
                            class="mb-5" 
                            v-model="item.salarm"
                            :label="t('search')"
                            variant="outlined"
                            density="compact"                      
                            hide-details                     
                            ></v-text-field>
                            <EasyDataTable
                            v-if="item.alarm.table.length > 0"
                            table-class-name="customize-table"
                            show-index
                            :headers="headersALEALA"
                            :items="item.alarm.table"
                            :rows-per-page="rows"
                            :search-value="item.salarm"
                            @click-row="showDialog"
                            >
                                <template #item-icon="item">
                                    <svg class="iconStatus" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="25px" viewBox="0 0 300.000000 300.000000" >
                                    <g v-html="getIMGsvg(item.tipo)"/>
                                    </svg>
                                </template>
                                
                                <template #item-ieo="item">
                                    <span>{{ getStatusIEO(item.host) }}</span>
                                </template>  
                            </EasyDataTable>
                            <p v-else>
                                <span> {{t('labels.noalarms')}} </span>
                            </p>
                        </v-col>
                    </v-row>
                </v-sheet>

                <v-sheet color="transparent" class="cardTopologys">
                    <v-row class="ma-0" justify="center">
                        <v-col :class="smAndDown ? 'pb-4 mb-4' : 'pa-0 px-4'" cols="12" sm="8" md="4" lg="4" xl="3">
                            <SingleCard :bottomText="t('labels.ok_pl')" :icon="'mdi-check'" :color-icon="COLOR.green" :middleText="item.ok.cant.toString()"/>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" sm="12" md="8" lg="8" xl="9" >
                            <v-text-field
                            v-if="item.ok.table.length > 0"
                            :style="'max-width: 400px !important;'"
                            class="mb-5" 
                            v-model="item.sok"
                            :label="t('search')"
                            variant="outlined"
                            density="compact"                      
                            hide-details                     
                            ></v-text-field>
                            <EasyDataTable
                            v-if="item.ok.table.length > 0"
                            table-class-name="customize-table"
                            show-index
                            :headers="headersOKDOWN"
                            :items="item.ok.table"
                            :rows-per-page="3"
                            :search-value="item.sok"
                            @click-row="showDialog"
                            >
                                <template #item-icon="item">
                                    <svg class="iconStatus" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="25px" viewBox="0 0 300.000000 300.000000" >
                                    <g v-html="getIMGsvg(item.tipo)"/>
                                    </svg>
                                </template>  
                                <template #item-ieo="item">
                                    <span>{{ getStatusIEO(item.ip) }}</span>
                                </template>  
                            </EasyDataTable>
                            <p v-else>
                                <span> {{t('labels.nook')}}  </span>
                            </p>
                        </v-col>
                    </v-row>
                </v-sheet>

                <v-sheet color="transparent" class="cardTopologys">
                    <v-row class="ma-0" justify="center">
                        <v-col :class="smAndDown ? 'pb-4 mb-4' : 'pa-0 px-4'" cols="12" sm="8" md="4" lg="4" xl="3">
                            <SingleCard :bottomText="t('labels.down_pl')" :icon="'mdi-close'" :color-icon="COLOR.greyfake" :middleText="item.down.cant.toString()"/>
                        </v-col>
                        <v-col class="pa-0 px-4" cols="12" sm="12" md="8" lg="8" xl="9" >
                            <v-text-field
                            v-if="item.down.table.length > 0"
                            :style="'max-width: 400px !important;'"
                            class="mb-5" 
                            v-model="item.sdown"
                            :label="t('search')"
                            variant="outlined"
                            density="compact"                      
                            hide-details                     
                            ></v-text-field>
                            <EasyDataTable
                            v-if="item.down.table.length > 0"
                            table-class-name="customize-table"
                            show-index
                            :headers="headersOKDOWN"
                            :items="item.down.table"
                            :rows-per-page="rows"
                            :search-value="item.sdown"
                            @click-row="showDialog"
                            >
                                <template #item-icon="item">
                                    <svg class="iconStatus" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                    width="25px" viewBox="0 0 300.000000 300.000000" >
                                    <g v-html="getIMGsvg(item.tipo)"/>
                                    </svg>
                                </template> 
                                <template #item-ieo="item">
                                    <span>{{ getStatusIEO(item.ip) }}</span>
                                </template> 
                            </EasyDataTable>
                            <p v-else>
                                <span> {{t('labels.nodown')}}  </span>
                            </p>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-sheet>

            <v-sheet v-if="!smAndDown" color="transparent" width='420' style="align-content: start">
                <GaugeComponent
                :recharge="false"
                :array-items="item.totalGaug"
                />
            </v-sheet>
        </v-row>

        
    </v-sheet>
    
    <v-dialog v-model="dialog" width="85%" >
        <DialogComponent
        v-if="dialog"
        :ip="ipValue"
        :typeSel="typeValue"
        :name="name"
        :marca="itemMarca"
        :status="finalStatus"
        @dialog="closeDialog"
        />
    </v-dialog>
</template>

<script setup lang="ts">
import { Ref, ref, onMounted, computed, watch } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { IMAGES_SVG } from '@/constants/images';
import { LABELS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 *********** VUETIFY ************
 *******************************/
import { useDisplay } from 'vuetify';
const { smAndDown } = useDisplay();

/********************************
 ************ ROUTER ************
 *******************************/
import router               from '@/router';

/********************************
 ********* INTERFACES ***********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables'
import { TOPOLOGYDATA, GENERAL_EQUIPAMENT } from '@/interfaces/SmartLink/Equips';
import { SNR }     from '@/interfaces/SmartLink/KPI';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getCountStatusTopology, getOperabilityLastDayTopology } from '@/services/Smartlink/Topology';

/**
 * Cantidad de Filas visibles en la tabla por página
 */
const rows      = ref(7);


/**
 * HEADER de la tabla de los equipo con estado OK y CAIDO
 */
const headersOKDOWN:Ref<HEADER[]> = ref([]); 

/**
 * HEADER de la tabla de los equipos con estado ALERTA Y ALARMA 
 */
const headersALEALA:Ref<HEADER[]> = ref([]);

/**
 * Regresa el modelo SVG del tipo de equipo
 * @param type Tipo de equipo
 */
function getIMGsvg(type:string) {
    let finalIMG = '';
    finalIMG = IMAGES_SVG[type.toLowerCase()];
    return finalIMG
}


/**
 * Regresa el ancho necesario para el gráfico
 * Si el parametro es 0, regresa 0px; si tiene algún valor, regresa 320px
 * @param count Cantidad de valores dentro del array de alertas/alarmas
 */
// const widthTimeLine = (count:number) => {
//     let cantidad = ''
//     count === 0 ? cantidad = '0px' : cantidad = '320px'
//     return cantidad
// }


/**
 * Lista de todos los equipos
 */
const countEquipStatus:Ref<TOPOLOGYDATA | undefined> = ref<TOPOLOGYDATA>(); 

/**
 * Captura la info de la API "getAllTopologyData"
 * lo ordena por nombre y de acuerdo al estado y su subtipo (distrution, access, client),
 * lo almacena en las variables correspondientes
 * - TODOS los valores se almacenan en las tablas correspondientes, en vez de hacer el match
 *  con los valores de alertas y alarmas que se obtenían de "getAlarmToDashBoard".
 * - Se hace un conteo de la cantidad de equipos en ok, alerta, alarma, caidos. Y ahora tendrán
 * el mismo valor, en el número y la tabla.
 */
async function getStatusData() {

    const allData = await getCountStatusTopology()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        countEquipStatus.value = allData.data
        matchALERTALARM();
    }

}

/**
 * Captura el objeto de la store (almacenado desde kpi-component)
 * y lo distribuye en "countEquipStatus", en cada una de las familias
 * "distribucion", "acceso", "cliente"
 * Los Valores son:
 * - La operabilidad TOTAL de los equipos para el componente GAUGE
 * - La operabilidad TOTAL de los equipos para el componente de la Linea de Tiempo
 * - Las alertas y alarmas de los equipos que se obtienen de la tabla EVENTOS Para el componente de alertas y alarmas
 * el cual se mostrará siempre y cuado hayan valores en ese array
 */
async function matchALERTALARM() {
    if(countEquipStatus.value) {
        let finalKPI = store.state.arrayTotalKPI;

        countEquipStatus.value.distri.totalGaug = finalKPI.distri.total;
        countEquipStatus.value.distri.totalAlar = finalKPI.distri.alarm;
        countEquipStatus.value.acceso.totalGaug = finalKPI.acceso.total;
        countEquipStatus.value.acceso.totalAlar = finalKPI.acceso.alarm;
        countEquipStatus.value.client.totalGaug = finalKPI.client.total;
        countEquipStatus.value.client.totalAlar = finalKPI.client.alarm;
    }
}

/**
 * Ip del equipo Seleccionado para el Dialogo
 */
const ipValue = ref('');

/**
 * Tipo del equipo Seleccionado para el Dialogo
 */
const typeValue = ref('');

/**
 * Nombre del equipo Seleccionado para el Dialogo
 */
const name = ref('');

/**
 * Marca del equipo Seleccionado para el Dialogo
 */
const itemMarca = ref('');

/**
 * Estado del equipo Seleccionado para el Dialogo
 */
const finalStatus = ref('');

/**
 * Valor del dialogo que se muestra al darle click a cualquier equipo en las tablas
 */
const dialog = ref(false);

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística
 * del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
function showDialog (item: GENERAL_EQUIPAMENT) {
    ipValue.value = item.ip??'';
    typeValue.value  = item.tipo??'';
    name.value = item.name??'';        
    itemMarca.value = item.marca??'';
    finalStatus.value = item.status??'';
    dialog.value = true;
}

/**
 * Cierra el dialog abierto
 */
function closeDialog (){
    dialog.value    = false;
}


/**
 * Variable que almacena todos los valores de estado por equipo
 * para realizar el IEO de cada EQUIPO en las últimas 24Horas
 */
const getAllIEOByIP:Ref<SNR[]> = ref([]);

/**
 * Captura la operatividad de todos los equipos 
 * en las ultimas 24 horas, agrupados por IP
 * y lo almacena en la variable "getAllIEOByIP"
 */
async function getAllOperabilityLastDay () { 
    
    const allData = await getOperabilityLastDayTopology()
    
    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        getAllIEOByIP.value = allData.data
    }

}
/**
 * Recibe una IP y busca sus valores (Cantidad de ok, alertas, alarmas, caidos)
 * dentro de la variable getAllIEOByIP
 * Si no encuentra un match, regresa valor 0
 * @param ipSearch String de la IP a buscar
 */
function getStatusIEO (ipSearch:string) {
    let ieo = 0;
    let total = 1;
    const findObject:SNR|undefined = getAllIEOByIP.value.find((objeto:SNR) => objeto.ip === ipSearch)
    if(findObject) {
        total = (findObject.ok??0) + (findObject.alarm??0) + (findObject.alert??0) + (findObject.down??0);

        //si el total es igual a 0, se regresa un valor igual a 0, para evitar que se generen NaN
        if(total === 0 ) {
            ieo = 0
        }
        else{
            ieo = parseFloat(((findObject.ok??0)/total).toFixed(2))
        }
    }
    return ieo
}


/****************************
********* ANIMATION *********
****************************/

/**
 * Captura el valor de # (HASH) extraido de la URL (solo usado en topologyview)
 */
const hashRoute = computed(() => router.currentRoute.value.hash)

watch(hashRoute, (hash:string) => {
    scroll(hash)
})

/**
 * Realiza una animación de desplazamiento hacia la ID del elemento HTML
 * @param id #HASH extraido de la URL
 */
function scroll (id:string) {
    const finalID = id.slice(1)
    const element = document.getElementById(`${finalID}`);    
    if(element){
        element.scrollIntoView({ behavior: 'smooth' });
    }
}


onMounted( async () => {

    headersOKDOWN.value = FINAL_HEADERS_TABLE['principal'];
    headersALEALA.value = FINAL_HEADERS_TABLE['principal'];
    await getAllOperabilityLastDay();
    await getStatusData();   

    //Se realiza la animación del scroll 100ms después de cargar la info la primera vez 
    setTimeout(() => {
        scroll(hashRoute.value)
    }, 100);
})

</script>

<style>
    .headTopo{
        scroll-margin: 90px;
    }

    .cardTopologys{
        border: 1px solid rgba(var(--v-theme-colorText),0.2);
        margin: 20px 0;
        padding: 20px 0;
        border-radius: 10px
    }

    .iconStatus g{ 
        fill: rgba(var(--v-theme-colorText)) !important;
    }
</style>